/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_ImplementersInputs */

const vi_tea_package_implementers = /** @type {(inputs: Tea_Package_ImplementersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người thực hiện`)
};

/**

* @param {Tea_Package_ImplementersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_implementers = /** @type {((inputs?: Tea_Package_ImplementersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_ImplementersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_implementers(inputs)
});